import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useSearchParams } from "react-router-dom";

const GlobalContext = React.createContext({
	locale: "en-US",
	toggleLocale: () => {
		//Added just for default state
	},
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setLocale: (newLocale: string) => {
		return;
	},
	isPreviewMode: false
});

type GlobalContextProviderProps = {
	children: React.ReactNode;
};

export const GlobalContextProvider = (props: GlobalContextProviderProps) => {
	const [searchParams] = useSearchParams();
	const [isPreviewMode, setIsPreviewMode] = useState(false);

	const initialLanguage =
		!i18n.language ||
		i18n.language == "en" ||
		i18n.language == "en-US" ||
		i18n.language == "en-CA"
			? "en-US"
			: "fr-CA";

	const [locale, setLocale] = useState(initialLanguage);

	const localeHandler = () => {
		if (locale === "en-US") {
			setLocale("fr-CA");
			i18n.changeLanguage("fr");
		} else if (locale === "fr-CA") {
			setLocale("en-US");
			i18n.changeLanguage("en");
		}
	};

	const changeLocale = (newLocale: string) => {
		setLocale(newLocale);
	};

	useEffect(() => {
		setIsPreviewMode(searchParams.has("preview"));
	}, []);

	return (
		<GlobalContext.Provider
			value={{
				locale: locale,
				toggleLocale: localeHandler,
				setLocale: changeLocale,
				isPreviewMode
			}}
		>
			{props.children}
		</GlobalContext.Provider>
	);
};

export default GlobalContext;
